<template>
<v-dialog
  :value="show"
  persistent
  @close="$emit('close')"
  max-width="600"
  :content-class="'ModalDetailOrder'"
  :class="'ModalDetailOrder'"
>
  <v-card class="ModalDetailOrder__card d-flex flex-column px-6 py-4">
    <div class="ModalDetailOrder__close d-flex justify-end">
      <v-btn
        small
        @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalDetailOrder__title">
      Информация о заказе
    </div>

    <div class="ModalDetailOrder__body" v-if="detailOrder && detailOrder.id">
      <div class="block">
        <p class="title">Фамилия и имя клиента</p>
        <span class="value">{{detailOrder.user_last_name}} {{detailOrder.user_first_name}}</span>
      </div>
      <div
        v-for="service of detailOrder.data.items"
        :key="service.service_card_id"
      >
        <div class="block pb-4" >
          <p class="title">Наименование услуги</p>
          <span class="value">{{service.service_name}} </span>
        </div>
        <div class="block" >
          <p class="title">Количество</p>
          <span class="value">{{service.quantity}} </span>
        </div>
      </div>

      <div class="block">
        <p class="title">Статус заказа</p>
        <span class="value">{{detailOrder.status_display}}</span>
      </div>
    </div>

    <div class="ModalDetailOrder__close d-flex justify-end">
      <v-btn
        small
        @click="$emit('close')">
        Закрыть
      </v-btn>
    </div>
  </v-card>

</v-dialog>

</template>

<script>
/**
 * Компонент: ModalDetailOrder
 * Описание:
 */
export default {
  name: 'ModalDetailOrder',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    detailOrder: {
      type: Object,
      default: () => {},
      required: true,
    }
  },
  emits: ['close'],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.ModalDetailOrder {
  background: red;
  &__card{
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close{
    & > button{
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
    text-align: start;
  }

  &__btn-group{
    display: flex;
    justify-content: center;
  }

  &__body{
    text-align: start;
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .block{
      & p.title {
        margin: 0;
        padding: 0;
        padding-bottom: 8px;
        color: black;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }
      & span.value{
        display: inline-block;
        padding: 11px 8px;
        width: 100%;
        outline: 1px solid #00000042;
        font-size: 14px;
        line-height: 130%;
        border-radius: 4px;
      }
    }
  }
}
</style>
